import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../Services/AxiosAPICaller';
import './CheckMailPopUp.css';

const CheckMailPopUp: React.FC = () => {

  const [email, setEmail] = useState<string>('');
  const [isMailValid, SetMailIsValid] = useState<boolean>(true);
  const [DomainAllowed, setDomainAllowed] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleCheckDomain = async (event: React.FormEvent) => {

    // Initialize variables we use those because state are not updated instantly
    let isInstantMailValid: boolean = false;
    let isInstantDomainAllowed: boolean = false;

    // Prevent form submission
    event.preventDefault();

    // Get email from input
    const emailInput = (document.getElementById('UserMail') as HTMLInputElement).value;
    setEmail(emailInput);

    // Check if email is valid
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailInput || emailInput === '' || !emailRegex.test(emailInput)) {
      SetMailIsValid(false);
      setDomainAllowed(false);
    }
    else {
      SetMailIsValid(true);
      isInstantMailValid = true;
    }

    // Get domain from email
    const domain = emailInput.split('@')[1];

    try {
      //we first check if the user already exist
      const UserExistresponse = await axiosInstance.get(`/users?filters[$and][0][email][$eq]=${emailInput}`);
      const UserAlreadyExist = UserExistresponse.data.length > 0;

      //if the user already exist we do nothing
      if (UserAlreadyExist) {
        setDomainAllowed(true);
        isInstantDomainAllowed = true;
      }

      else {
        // Get authorized domains from API
        await axiosInstance.get<{ data: { id: number, attributes: any }[] }>(`/noms-de-domaines-autorises`)
          .then(response => {
            // check if returned data is an array
            if (Array.isArray(response.data.data)) {
              // Create DomainName Object From API returned Datas
              const authorizedDomains = response.data.data.map(item => (
                {
                  Name: item.attributes.Nom_de_domaine,
                  IsActive: item.attributes.Actif
                }));

              // Check if domain enterred by user is in the authorized domains list and is active
              if (authorizedDomains.some(authDomain => authDomain.Name.includes(domain) && authDomain.IsActive)) {
                // Domain is authorized
                console.log('Domain allowed!');
                setDomainAllowed(true);
                isInstantDomainAllowed = true;
              }
              else {
                // Domain is not authorized
                console.log('Domain not allowed!');
                setDomainAllowed(false);
                isInstantDomainAllowed = false;
              }
            }
            else {
              // Error in API response
              setDomainAllowed(false);
            }
          })
       }

       // If email and domain are valid, redirect to adequate page
       if (isInstantMailValid) {

        if (!isInstantDomainAllowed) {
          navigate(`/AccessForm?email=${email}`);
        }

        else {
          // SendMail with Authentication link
          axiosInstance.post('/passwordless/send-link', {
            email: emailInput,
            username: emailInput,
            context: {
              // context of authentification, optional parameter e.g. "currentUrl": "...my page..."
            }
          })
            .then(() => {
              // if mail is sent, redirect to AccessSendMail page
              navigate(`/AccessSendMail`);
            })
            .catch(error => {
              console.error('Error sending email:', error);
            });

        }

       
      }

    }
    catch (error) {
      console.error('Error checking domain:', error);
    }
  };

  return (
    <div className="MailCheckForm-container">
      <form>
        <label htmlFor="nameField" className="form-label">Veuillez renseigner votre adresse mail</label>
        <input
          type="email"
          id="UserMail"
          placeholder="Votre mail"
          className="form-input"
          onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
        />
        <button type="submit" className="form-button" onClick={(e) => handleCheckDomain(e)}>Valider</button>
        {!DomainAllowed && !isMailValid && <p className="error-message">Veuillez entrer une adresse mail valide.</p>}
      </form>
    </div>
  );
};

export default CheckMailPopUp;